export default __webpack_public_path__ + "static/media/hhn12.441dd7af.png";